import dayjs from "dayjs";
import { CompanyReportMapper } from "@/adapters/CompanyReport.mapper";
import { CORP_ORDER_COLUMNS } from "@/types/company/report.dto";
import { toB2BError, toDataShapeError } from "@/utils/b2bErrors";
import { lazyService } from "@/utils/lazyMock";
import { supabase } from "@/utils/supabase";
/** Границы диапазона дат в МСК (UTC+3) для `charged_at` — timestamptz колонка. */
const mskBoundary = (date, offsetDays) => `${dayjs(date).add(offsetDays, "day").format("YYYY-MM-DD")}T00:00:00+03:00`;
export class CompanyReportService {
    async getReport(companyId, params) {
        const { data, error } = await supabase().rpc("corp_report_orders", {
            p_company_id: companyId,
            p_date_from: params.dateFrom,
            p_date_to: params.dateTo,
            p_group_by: params.groupBy,
        });
        if (error)
            throw toB2BError(error);
        try {
            return CompanyReportMapper.reportToDomain(data);
        }
        catch (parseError) {
            throw toDataShapeError(parseError);
        }
    }
    /** Полный набор (без пагинации) — реестр заказов отчёта за период. */
    async listOrders(companyId, dateFrom, dateTo) {
        const { data, error } = await supabase()
            .from("v_corp_orders")
            .select(CORP_ORDER_COLUMNS)
            .eq("company_id", companyId)
            .eq("is_charged", true)
            .gte("charged_at", mskBoundary(dateFrom, 0))
            .lt("charged_at", mskBoundary(dateTo, 1))
            .order("charged_at");
        if (error)
            throw toB2BError(error);
        try {
            return (data ?? []).map(CompanyReportMapper.orderToDomain);
        }
        catch (parseError) {
            throw toDataShapeError(parseError);
        }
    }
}
// Литерал REACT_APP_B2B_MOCK — см. CompanyLinkService.ts / utils/lazyMock.ts (G4).
export const companyReportService = process.env.REACT_APP_B2B_MOCK === "true"
    ? lazyService(() => import("@/services/mock/CompanyReportServiceMock").then((module) => module.companyReportServiceMock))
    : new CompanyReportService();
